export const japanPhotoInformation = {
         tokyo_fear: {
           date: "2019-08-30",
           location: "Chuo City, Tokyo",
           description: [
             "After a meal of delicious Japanese BBQ, I was forced against my will to eat a round of offal.",
             "I had tried motsunabe the day before and already knew that offal wasn't for me, thus my look of horror.",
           ],
         },
         tokyo_ginza_sushi: {
           date: "2019-08-21",
           location: "Kyubey, Chuo City, Tokyo",
           description: [
             "Sushi chef at work during our lunch at Kyubey in Ginza.",
           ],
         },
         tokyo_mtfuji_1: {
           date: "2019-08-22",
           location: "Mt. Fuji",
           description: [
             "On our second day in Japan (still massively jetlagged), we rode the bus to Shizuoka and completed an overnight hike up Mt. Fuji where we were rewarded with this glorious sunrise.",
             "I also experienced a huge crash later that day (after nearly two full days without sleep), culminating in me falling asleep upright on the subway and losing my bus pass :')",
           ],
         },
         tokyo_mtfuji_2: {
           date: "2019-08-22",
           location: "Mt. Fuji",
           description: [
             "Yet another angle of the sunrise from Fuji. There was something surreal about standing up there watching the rays of the sun kiss the clouds.",
           ],
         },
         tokyo_museum_hat: {
           date: "2019-08-20",
           location: "Tokyo National Museum",
           description: [
             "This one's pretty self-explanatory: I found a cool hat and put it on. The museum also provided cool audio info through the headphones in order to provide more context for the artwork on display.",
           ],
         },
         tokyo_outside_sushidai: {
           date: "2019-08-20",
           location: "Sushi Dai, Koto City, Tokyo",
           description: [
             "A picture of the view outside Sushi Dai.",
             "This was our first real meal in Japan, slept for an hour and immediately got up to line up at 3 AM so we could get in when it opened at 6 AM. We were fed wrong info though, the other customers only started showing up at around 4:30 AM.",
           ],
         },

         aichi_lamp: {
           date: "2019-08-23",
           location: "Nagoya, Aichi",
           description: [
             "A lamp post outside the restaurant Atsuta Horaiken. We were served the greatest unagi don here. It really made us want to just keep eating unagi for the rest of our trip.",
           ],
         },
         aichi_street: {
           date: "2019-08-23",
           location: "Nagoya, Aichi",
           description: [
             "Snapped this while crossing a bridge on our way to dinner. Though not much of a subject in these types of pictures, I tend to take a number of mundane photos just to help me document my entire experience, not just the highs.",
           ],
         },
         aichi_udon: {
           date: "2019-08-23",
           location: "Nagoya, Aichi",
           description: [
             "On our way to Nagoya Castle, we passed by this udon joint. A few seconds later we looked at each other and agreed we had to go back to try the udon.",
             "Good decision on our part.",
           ],
         },

         kyoto_bird: {
           date: "2019-08-24",
           location: "Maruyama Park, Kyoto",
           description: ["Cool bird on a rock."],
         },
         kyoto_sit: {
           date: "2019-08-24",
           location: "Maruyama Park, Kyoto",
           description: [
             "A pair of sisters in the wild.",
             "I remember being a little nervous I would tip myself backwards.",
           ],
         },
         kyoto_street: {
           date: "2019-08-24",
           location: "Shimogyo, Kyoto",
           description: [
             "I have a strange affinity for the streets of Japan.",
             "Maybe it's the architecture, maybe it's the anime vibes. I guess we'll never know.",
           ],
         },
         kyoto_train: {
           date: "2019-08-25",
           location: "Kyoto Station",
           description: ["A piece of Japan's intricate train system."],
         },

         nara_deer_1: {
           date: "2019-08-26",
           location: "Nara Park",
           description: [
             "Tourists visit Nara for the deer and sad to say, we were no different.",
           ],
         },
         nara_deer_2: {
           date: "2019-08-26",
           location: "Nara Park",
           description: ["My deer friend."],
         },
         nara_mochi: {
           date: "2019-08-26",
           location: "Nara Park",
           description: [
             "Never one to refuse food, I also stuffed myself on fresh red bean mochi.",
           ],
         },

         osaka_takoyaki: {
           date: "2019-08-26",
           location: "Dotonburi, Osaka",
           description: [
             "We didn't spend too long in Osaka but we did check out Dotonburi and ate some street snacks.",
           ],
         },

         fukuoka_bridge: {
           date: "2019-08-28",
           location: "Fukuoka",
           description: ["Me on a bridge."],
         },
         fukuoka_funnymen: {
           date: "2019-08-29",
           location: "Fukuoka",
           description: ["Funny men on the placemat of an unagi restaurant."],
         },
         fukuoka_museum: {
           date: "2019-08-29",
           location: "Fukuoka",
           description: [
             "One of my favourite pieces at a museum we walked into on a whim.",
           ],
         },
       }
